import { __assign, __rest } from "tslib";
import React from 'react';
import { useComponentRegistry } from '@bem-react/di';
import { cnMenu } from '../Menu';
import { useMenuItem } from '../Menu.hooks/useMenuItem';
export var MenuItem = function (_a) {
    var needIconGlyph = _a.needIconGlyph, children = _a.children, innerRef = _a.innerRef, value = _a.value, props = __rest(_a, ["needIconGlyph", "children", "innerRef", "value"]);
    var _b = useComponentRegistry(cnMenu()), Text = _b.Text, Icon = _b.Icon;
    var itemProps = useMenuItem(props);
    return (React.createElement("div", __assign({ ref: innerRef }, itemProps),
        needIconGlyph && React.createElement(Icon, { glyph: "type-check" }),
        React.createElement(Text, null, children)));
};
